/**
 * 商品企画マスタ画面　選定解除VOクラス
 */
export class KYMW1300DeletePlanModel {

  public orderCode: string = null;                                              // 受注コード
  public mediumType: string = null;                                             // 媒体区分
  public bundleCatalogRoundId: string = null;                                     // 束ね企画回ID
  public pCodeList: Array<string> = new Array<string>();                        // Ｐコードリスト

}
